export enum AnalyticsSignUpEvents {
    GetStarted = "Get started",
    SwitchToLogin = "Switch to login screen",
    depositPlan = "Deposit plan",
    rentPlan = "rent plan",
    depositAndRentPlan = "Deposit + rent plan",
    FullNameEntered = "Full name entered",
    WorkEmail = "Work Email entered",
    Company = "Company name entered",
    StartOver = "Start over selected",
    StartOverConfirmed = "Start over confirmed",
    Waive = "Waive", // didnt paid,
    Reeedem = "Redeem", // paid,
    InsertAmount = "Insert amount",
    NoAmount = "No amount",
    OpenPlaid = "Open plaid",
    ExitPlaid = "Exit plaid",
    PlaidGood = "Plaid finished",
    IdSuccess = "Id success",
    IDFailure = "Id failure",
    LeaseUploaded = "Lease uploaded",
    NoLease = "No lease",
    CmEmail = "Contact manager Email",
    CmEmailSkipped = "Contact manager Email skipped",
    PriceQuotePayment = "Price quote payment", // final price true
    VerifyPayment = "Verify Payment", // final price false
    PaymentApproved = "Payment approved",
    ApplicationUnderReview = "Application under review",
    ApplicationApproved = "Application approved",
    PlanSelected = "Plan selection",
    FullBusinessDetails = "Submitted business details",
    ApplicationCompleted = "Application completed"

}



// WEBPACK FOOTER //
// ./src/services/Analytics/AnalyticsSignUpEvents.ts